class HandDivider {
    constructor() {
        this.tileTypes = ["m", "p", "s", "z"];
    }

    // 标准化牌表示（处理赤宝牌）
    normalizeTile(tile) {
        const [num, type] = tile.split(/(\D)/);
        if (num === "0") return `5${type}`;
        return tile;
    }

    // 判断是否为刻子
    isTriplet(tiles) {
        return tiles[0] === tiles[1] && tiles[1] === tiles[2];
    }

    // 判断是否为顺子
    isSequence(tiles) {
        const [tile1, tile2, tile3] = tiles;
        const [num1, type1] = tile1.split(/(\D)/);
        const [num2, type2] = tile2.split(/(\D)/);
        const [num3, type3] = tile3.split(/(\D)/);

        return type1 === type2 && type2 === type3 && parseInt(num1) + 1 === parseInt(num2) && parseInt(num2) + 1 === parseInt(num3);
    }

    // 判断是否为面子
    isMeld(tiles) {
        return this.isTriplet(tiles) || this.isSequence(tiles);
    }

    // 递归查找所有面子组合
    findMelds(hand, currentMelds = [], results = []) {
        if (hand.length === 2) {
            // 检查是否为对子
            if (hand[0] === hand[1]) {
                results.push([...currentMelds, hand]);
            }
            return;
        }

        // 遍历所有可能的三张牌组合
        for (let i = 0; i < hand.length - 2; i++) {
            for (let j = i + 1; j < hand.length - 1; j++) {
                for (let k = j + 1; k < hand.length; k++) {
                    const candidate = [hand[i], hand[j], hand[k]];

                    // 字牌不參與判斷，因為字牌只能組成刻子
                    const isAllHonor = candidate.every((tile) => tile.endsWith("z"));
                    if (isAllHonor && new Set(candidate).size !== 1) {
                        continue; // 字牌必須是刻子，若不是相同的3張則跳過
                    }

                    if (this.isMeld(candidate)) {
                        // 移除已使用的牌
                        const remaining = hand.filter((_, index) => index !== i && index !== j && index !== k);
                        // 递归查找剩余牌的面子组合
                        this.findMelds(remaining, [...currentMelds, candidate], results);
                    }
                }
            }
        }
    }

    // 主分解方法
    decomposeHand(hand) {
        const normalizedHand = hand.map((tile) => this.normalizeTile(tile)).sort();
        const results = [];
        this.findMelds(normalizedHand, [], results);

        const uniqueResults = Array.from(
            new Set(
                results.map((melds) =>
                    JSON.stringify({
                        melds: melds.sort(),
                    })
                )
            )
        ).map((jsonStr) => JSON.parse(jsonStr));

        const formattedResults = uniqueResults.map((result) => {
            return [...result.melds.map((meld) => ({ type: this.getMeldType(meld), tiles: meld }))];
        });

        // 格式化结果
        return formattedResults;
    }

    getMeldType(meld) {
        if (meld.length === 3) {
            if (this.isTriplet(meld)) {
                return "手牌刻子"; // 刻子 (三張相同牌)
            } else if (this.isSequence(meld)) {
                return "手牌順子"; // 順子 (連續數字)
            }
        }
        if (meld.length === 2) {
            return "手牌雀頭"; // 雀頭 (兩張相同牌)
        }
        return "未知類型";
    }
}

export default HandDivider;
